import { render, staticRenderFns } from "./edit_explain.vue?vue&type=template&id=5d88911e&"
import script from "./edit_explain.vue?vue&type=script&lang=js&"
export * from "./edit_explain.vue?vue&type=script&lang=js&"
import style0 from "./edit_explain.vue?vue&type=style&index=0&id=5d88911e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports